import React, { memo } from 'react';
import GroupSection from './GroupSection';

const OptionGroups = memo(({ disabled, multiSchema, selected, ...otherProps }) => {
    return multiSchema.reduce((arr, item) => {
        const disabledArr = disabled?.[item.id]?.options || [];
        const id = item.id;
        const selectedObj = selected[id] || {};
        const isSelected = selectedObj.overrideIsSelected || selectedObj.isSelected;

        if (!isSelected) return arr;

        arr.push(
            <GroupSection
                disabled={disabledArr}
                item={item}
                key={id}
                selected={selectedObj}
                {...otherProps}
            />,
        );

        return arr;
    }, []);
});

export default OptionGroups;
